import { Container, Paper, Tab, Tabs } from "@mui/material";
import useCart from "../../../hooks/context/useCart";
import { useEffect, useState } from "react";
import useAuth from "../../../hooks/context/useAuth";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import { colors } from "../../../theme/colors";
import { CartStep } from "./steps/CartStep";
import { CheckoutStep } from "./steps/CheckoutStep";
import { FadeInContainer } from "../../../components/AtomicDesign/Atoms";
import { useBreakpoints } from "../../../hooks/useBreakpoins";
import { useLocation } from "react-router-dom";

export function Cart() {
  const { updateCart, removeFromMyCart, getCart } = useCart();
  const { pathname } = useLocation();
  const { isMobile } = useBreakpoints();
  const { user } = useAuth();
  const [selectedProducts, setSelectedProducts] = useState<CartXProduct[]>([]);
  const [selectedAddressID, setSelectedAddressID] = useState(0);
  const [selectedFrete, setSelectedFrete] = useState({
    freteType: "",
    value: "",
  });
  const [tabStep, setTabStep] = useState(1);

  const selectOrRemove = (cart: CartXProduct) => {
    const verify = selectedProducts?.find(
      (selectedPRD) => selectedPRD?.product?.id === cart?.product?.id
    );
    if (verify) {
      const remove = selectedProducts?.filter(
        (selectedPRD) => selectedPRD?.product?.id !== cart?.product?.id
      );
      setSelectedProducts(remove);
    } else {
      setSelectedProducts((old) => [...old, cart]);
    }
  };

  const addToCart = async (productID: number, quantity: number) => {
    await updateCart({
      cartID: user?.cartID,
      productID: productID,
      quantity: quantity,
    });
    if (selectedProducts.some((item) => item?.product?.id === productID)) {
      const remove = selectedProducts?.filter(
        (selectedPRD) => selectedPRD?.product?.id !== productID
      );
      setSelectedProducts(remove);
    }
  };

  const removeFromCart = async (productID: number, quantity: number) => {
    await removeFromMyCart({
      cartID: user?.cartID,
      productID: productID,
      quantity: quantity,
    });
    if (selectedProducts.some((item) => item?.product?.id === productID)) {
      const remove = selectedProducts?.filter(
        (selectedPRD) => selectedPRD?.product?.id !== productID
      );
      setSelectedProducts(remove);
    }
  };

  const tabButtons = { minHeight: "50px", height: "50px" };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (pathname === "/checkout/mycart" && tabStep === 1 && user?.user?.id) {
      getCart(true);
    }
    // eslint-disable-next-line
  }, [tabStep, pathname]);

  return (
    <Container maxWidth={"xl"}>
      <Paper elevation={3} sx={{ mt: isMobile ? 5 : 10, p: 1 }}>
        <Tabs
          value={tabStep}
          variant="fullWidth"
          indicatorColor={"secondary"}
          sx={{
            "& .Mui-selected": {
              borderRadius: "5px 5px 0 0",
              color: colors.purple[500],
            },
            "& .MuiTab-root": {
              fontSize: 16,

              "&: hover": {
                borderRadius: "5px 5px 0 0",
              },
              pointerEvents: "none",
            },
          }}
        >
          <Tab
            icon={<ShoppingCartOutlinedIcon />}
            iconPosition="start"
            value={1}
            label="Meu carrinho"
            sx={tabButtons}
          />
          <Tab
            sx={tabButtons}
            value={2}
            label="Pagamento"
            icon={<ShoppingCartCheckoutIcon />}
            iconPosition="start"
          />
        </Tabs>

        {tabStep === 1 && (
          <FadeInContainer>
            <CartStep
              addToCart={addToCart}
              selectOrRemove={selectOrRemove}
              selectedProducts={selectedProducts}
              setStep={() => setTabStep(2)}
              removeFromCart={removeFromCart}
              step={tabStep}
              setSelectedAddressID={setSelectedAddressID}
              selectedAddressID={selectedAddressID}
              setSelectedFrete={setSelectedFrete}
              selectedFrete={selectedFrete}
            />
          </FadeInContainer>
        )}
        {tabStep === 2 && (
          <FadeInContainer>
            <CheckoutStep
              cleanStateCart={() => setSelectedProducts([])}
              selectedProducts={selectedProducts}
              setStep={() => setTabStep(1)}
              step={tabStep}
              selectedAddressID={selectedAddressID}
              setSelectedAddressID={setSelectedAddressID}
              setSelectedFrete={setSelectedFrete}
              selectedFrete={selectedFrete}
            />
          </FadeInContainer>
        )}
      </Paper>
    </Container>
  );
}
